/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __ol__ = _interopDefault(require('openlayers'));
var imageStyle = _interopDefault(require('../mixin/image-style'));
var minilo = require('../util/minilo');
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));

var Icon = __ol__.style.Icon;
var props = {
  src: {
    type: String,
    required: true
  },
  size: {
    type: Array,
    validator: function validator(value) {
      return value.length === 2;
    }
  },
  anchor: {
    type: Array,
    default: function _default() {
      return [0.5, 0.5];
    },
    validator: function validator(value) {
      return value.length === 2;
    }
  },
  anchorOrigin: {
    type: String,
    default: 'top-left' // bottom-left, bottom-right, top-left or top-right
  },
  anchorXUnits: {
    type: String,
    default: 'fraction' // pixels, fraction
  },
  anchorYUnits: {
    type: String,
    default: 'fraction' // pixels, fraction
  },
  color: [Array, String],
  crossOrigin: String,
  offset: {
    type: Array,
    default: function _default() {
      return [0, 0];
    },
    validator: function validator(value) {
      return value.length === 2;
    }
  },
  offsetOrigin: {
    type: String,
    default: 'top-left' // bottom-left, bottom-right, top-left or top-right
  },
  opacity: {
    type: Number,
    default: 1
  },
  scale: {
    type: Number,
    default: 1
  },
  rotateWithView: {
    type: Boolean,
    default: false
  },
  rotation: {
    type: Number,
    default: 0
  }
};

var methods = {
  /**
   * @return {ol.style.Icon}
   * @protected
   */
  createStyle: function createStyle() {
    return new Icon({
      anchor: this.anchor,
      anchorOrigin: this.anchorOrigin,
      anchorXUnits: this.anchorXUnits,
      anchorYUnits: this.anchorYUnits,
      color: this.color,
      crossOrigin: this.crossOrigin,
      offset: this.offset,
      offsetOrigin: this.offsetOrigin,
      opacity: this.opacity,
      scale: this.scale,
      snapToPixel: this.snapToPixel,
      rotateWithView: this.rotateWithView,
      rotation: this.rotation,
      size: this.size,
      src: this.src
    });
  }
};
// todo other watchers
var watch = {
  src: function src(value) {
    if (this.$style && !minilo.isEqual(value, this.$style.getSrc())) {
      this.scheduleRefresh();
    }
  },
  size: function size(value) {
    if (this.$style && !minilo.isEqual(value, this.$style.getSize())) {
      this.scheduleRefresh();
    }
  },
  anchor: function anchor(value) {
    if (this.$style && !minilo.isEqual(value, this.$style.getAnchor())) {
      this.scheduleRefresh();
    }
  },
  scale: function scale(value) {
    if (this.$style && !minilo.isEqual(value, this.$style.getScale())) {
      this.scheduleRefresh();
    }
  }
};

var Style = {
  name: 'vl-style-icon',
  mixins: [imageStyle],
  props: props,
  methods: methods,
  watch: watch
};

/**
 * @alias module:icon-style
 */
var index = {
  /**
   * @alias module:icon-style/style
   */
  Style: Style,
  /**
   * @param {Vue} Vue
   * @param {VueLayersOptions} [options]
   */
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    options = minilo.pick(options, 'dataProjection');
    _Object$assign(Style, options);

    Vue.component(Style.name, Style);
  }
};

module.exports = index;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/icon-style/index.js
// module id = 1463
// module chunks = 1